var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "stuClassroom",
      attrs: {
        "element-loading-text": "正在加载教室，请稍候",
        "element-loading-background": "rgba(255, 255, 255, 0.9)",
      },
    },
    [
      _c("classroomHeader", {
        attrs: {
          type: "student",
          lessonTime: _vm.lessonTime,
          teduBoard: _vm.teduBoard,
          lessonType: _vm.lessonType,
          cameraStream: _vm.cameraStream,
        },
        on: { handlerStuTab: _vm.handlerStuTab },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "classroomBody" }, [
        _c("audio", { attrs: { src: _vm.voiceUrl } }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "boardBox" },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.classData.currentTab == "board" && !_vm.screenShare,
                    expression:
                      "classData.currentTab == 'board' && !screenShare",
                  },
                ],
                staticStyle: { width: "100%", height: "100%" },
              },
              [
                _c("div", {
                  staticClass: "masking",
                  attrs: { oncontextmenu: "return false;" },
                }),
                _vm._v(" "),
                _c("PanoWhiteboard"),
              ],
              1
            ),
            _vm._v(" "),
            _vm.screenShare ? _c("MainView") : _vm._e(),
            _vm._v(" "),
            _vm.lessonLoading && _vm.lessonTab == "lesson"
              ? _c("LiveLoading")
              : _vm._e(),
            _vm._v(" "),
            (_vm.lessonType == "scratch" && _vm.scratchPostMessage) ||
            _vm.classData.currentTab == "editor_scratch"
              ? _c("iframe", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.classData.currentTab == "editor_scratch",
                      expression: "classData.currentTab == 'editor_scratch'",
                    },
                  ],
                  attrs: {
                    id: "scIframe",
                    width: "100%",
                    height: "100%",
                    src: `https://${_vm.hostname}/scratch${
                      _vm.worksId
                        ? "?worksId=" +
                          _vm.worksId +
                          "&live=1&timestamp=" +
                          _vm.timestamp
                        : "?live=1"
                    }`,
                    frameborder: "0",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.lessonType == "python"
              ? _c("iframe", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.classData.currentTab == "editor_python",
                      expression: "classData.currentTab == 'editor_python'",
                    },
                  ],
                  attrs: {
                    id: "pyIframe",
                    width: "100%",
                    height: "100%",
                    src: `https://${_vm.hostname}/python${
                      _vm.worksId
                        ? "?worksId=" +
                          _vm.worksId +
                          "&lessonId=" +
                          _vm.lessonId +
                          "&timestamp=" +
                          _vm.timestamp
                        : "?lessonId=" + _vm.lessonId
                    }`,
                    frameborder: "0",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "userListBox" },
          [
            _c("SmallVideoList"),
            _vm._v(" "),
            _vm.roomSuccess
              ? _c("ChatArea", {
                  ref: "chatArea",
                  attrs: { enableChat: _vm.enableChat },
                  on: {
                    handlerStuSaveWorksFn: _vm.handlerStuSaveWorks,
                    stuLoadWork: _vm.stuLoadWork,
                    chatSwitch: _vm.chatSwitch,
                    changeTab: _vm.changeTab,
                    defaultSettings: _vm.defaultSettings,
                    stopClass: _vm.stopClass,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("CardAnimation", {
        ref: "cardAnimationRef",
        attrs: { img: _vm.awardCardImg },
      }),
      _vm._v(" "),
      _c("promptChangedDialog", {
        attrs: { promptShow: _vm.promptShow },
        on: {
          saveWork: _vm.onSaveWork,
          unSaveWork: _vm.onUnSaveWork,
          cancel: _vm.onCancel,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/classroom1/student.vue?vue&type=template&id=5d0f87f8&
// module id = null
// module chunks = 